const ANONYMOUS_CACHE_NAMESPACE = 'anonymous';

const normalizeUserId = (userId?: string | null): string | null => {
  if (typeof userId !== 'string') return null;
  const normalized = userId.trim();
  return normalized.length > 0 ? normalized : null;
};

let cacheNamespace = ANONYMOUS_CACHE_NAMESPACE;

export const resolveCacheNamespace = (userId?: string | null): string => {
  const normalizedUserId = normalizeUserId(userId);
  if (!normalizedUserId) {
    return ANONYMOUS_CACHE_NAMESPACE;
  }
  return `user:${normalizedUserId}`;
};

export const setCacheNamespace = (userId?: string | null): void => {
  cacheNamespace = resolveCacheNamespace(userId);
};

export const getCacheNamespace = (): string => cacheNamespace;

export const scopeQueryKey = (parts: readonly unknown[]): readonly unknown[] => [
  'scope',
  cacheNamespace,
  ...parts,
];

export const buildNamespacedStorageKey = (baseKey: string, suffix?: string): string => {
  const normalizedSuffix = typeof suffix === 'string' && suffix.length > 0 ? `:${suffix}` : '';
  return `${baseKey}:${cacheNamespace}${normalizedSuffix}`;
};

export const buildStorageKeyForNamespace = (
  baseKey: string,
  namespace: string,
  suffix?: string,
): string => {
  const normalizedSuffix = typeof suffix === 'string' && suffix.length > 0 ? `:${suffix}` : '';
  return `${baseKey}:${namespace}${normalizedSuffix}`;
};
